<!-- Main menu -->
<div class="navbar-container main-menu-content navbar-outer-container">
  <ul class="nav navbar-nav" id="main-menu-navigation" layout="horizontal" core-menu></ul>


<div class="sign-in-container">
  <a *ngIf="!isLoggedIn" class="button" href="./login" routerLinkActive="active"><span>Sign in</span></a>
</div>
</div>

<!--/ Main menu -->

<!-- *ngIf='isloggedin' (click)="login()" -->